import styled from "styled-components"

import Button from "components/buttons/shared"
import shadowCSS from "components/shadow"

const BeamButton = styled(Button)`
  background-color: ${props => props.theme.colors.apricot};
  color: ${props => props.theme.colors.charcoal};

  ${props =>
    !props.loading &&
    `
    :hover:not([disabled]), :active {
      background-color: ${props.theme.colors.tangerine};
      color: ${props.theme.colors.white};
    }

    :focus:not([disabled]) {
      outline-color: ${props.theme.colors.coolGrey};
    }
  `}

  ${props => (props.noShadow ? "" : shadowCSS)}
`

export default BeamButton
